<template>
  <div>
    <form @submit.prevent class="login-form-box login-pagegap">
      <div class="logo-img">
        <v-img
          max-height="60"
          max-width="230"
          :src="logo_image"
          :lazy-src="logo_image"
        >
        </v-img>
      </div>
      <h4 class="welcome-text">Welcome!</h4>
      <v-row>
        <v-col>
          <v-text-field
            class="p-0 m-0"
            v-model="email"
            :error-messages="emailErrors"
            label="Email Address*"
            placeholder="Enter Email"
            required
            @input="$v.email.$touch()"
            @blur="$v.email.$touch()"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="relative col passwordbox">
          <v-text-field
            :type="show_password ? 'text' : 'password'"
            v-model="password"
            :error-messages="passwordErrors"
            label="Password*"
            :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
            @input="$v.password.$touch()"
            @blur="$v.password.$touch()"
            @click:append="show_password = !show_password"
            placeholder="Enter Password"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-checkbox
            v-model="remember_me"
            label="Remember me"
            class="m-0"
          ></v-checkbox>
        </v-col>
        <v-col class="text-right">
          <v-btn class="forgotpassword-link" @click="forgotpassword">
            Forgot Password?
          </v-btn>
        </v-col>
      </v-row>
      <span
        v-bind:class="{ 'error-messagebox-login': isAddClassServerError }"
        id="server_side_error"
        >{{ serverError }}</span
      >
      <v-row>
        <v-col>
          <v-btn
            class="blue-btn"
            @click="submit"
            :disabled="!isFormValid"
            :error-messages="buttonErrorMessage"
          >
            sign in
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <p class="sign-up-box">
            Don't have an account?
            <v-btn @click="signup" class="sign-up-btn"> sign up </v-btn>
          </p>
        </v-col>
      </v-row>
    </form>

    <modal name="restore-popup" class="common-modal-box">
      <div class="modal-inner">
        <div class="popup-image">
          <v-img
            width="20"
            height="20"
            style="float: center"
            :src="require('@/assets/images/user-blocked.png')"
          >
          </v-img>
        </div>

        <p>
          Your account has been deleted. Do you want to restore account ? (You
          can restore your account within {{ date }} days only.)
        </p>
        <div class="buttons">
          <v-btn @click="restore" class="restore-btn">Restore </v-btn>
          <v-btn @click="cancelRestore" class="cancel-btn">Cancel</v-btn>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import {
  USER_SIGNIN,
  USER_DETAILS,
  VERIFY_EMAIL_OTP,
  GET_PAYMENT_INFO,
} from "../../store/actions.type";
import { validationMixin } from "vuelidate";
import {
  required,
  email,
  minLength,
  maxLength,
  sameAs,
  numeric,
} from "vuelidate/lib/validators";
import { Auth } from "aws-amplify";
import JwtService from ".././common/jwt.service";
import { isEmpty } from "lodash";
import axios from "axios";
export default {
  mixins: [validationMixin],

  validations: {
    email: { required, email },
    password: {
      required,
      minLength: minLength(8),
      validateString: function (value) {
        const containsUppercase = /[A-Z]/.test(value);
        const containsLowercase = /[a-z]/.test(value);
        const containsNumber = /[0-9]/.test(value);
        const containsSpecial = /[#?!@$%^&*-]/.test(value);
        return (
          containsUppercase &&
          containsLowercase &&
          containsNumber &&
          containsSpecial
        );
      },
    },
  },

  data: () => ({
    email: "",
    password: "",
    remember_me: false,
    passwordType: "password",
    status: "Show Password",
    btnText: "Show",
    show_password: false,
    show_confirm_password: false,
    image: require("@/assets/images/logo.png"),
    serverError: "",
    date: "",
    isFormValid: true,
    isAddClassServerError: false,
    logo_image: process.env.VUE_APP_ROOT_ICONS_URL + "Logo.png",
    error_message: "",
    success_message: "",
    name: "",
    mobile_no: "",
    is_show_payemnt_confirmation_popup: true,
    reset_password_status:'no'
  }),

  mounted() {},

  computed: {
    emailErrors() {
      const errors = [];
      this.serverError = "";
      this.isAddClassServerError = "";
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid email");
      !this.$v.email.required && errors.push("Email is required");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      this.serverError = "";
      this.isAddClassServerError = "";
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("Password is required.");
      !this.$v.password.minLength;
      !this.$v.password.validateString;
      return errors;
    },
    buttonErrorMessage() {
      if (this.$v.$invalid) {
        this.isFormValid = false;
      } else {
        this.isFormValid = true;
      }
    },
  },

  methods: {
    cancelRestore() {
      window.location.href = "/";
      // this.$router.push({ name: "/" }).catch(() => {});
      this.$modal.hide("restore-popup");
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.onClickRememberme();
      this.$loading(true);
      localStorage.setItem('investometer_member_id','')
      Auth.signIn(this.email, this.password)
        .then((data) => {
          this.$store
            .dispatch(USER_SIGNIN, {
              data: {
                device_iemi_no: "1234567898765432",
                aws_cognito_id: data.attributes["sub"],
                firebase_token: data.attributes["sub"],
                device_info: "desktop",
              },
              api: "login",
            })
            .then(() => {
              let response = this.$store.getters.getUserSignin.data;
              // this.$loading(false);
              if (response.status == "error") {
                this.serverError = response.message;
                return [];
              } else {
                this.date = response.remaining_days;
                //  console.log(this.date);
                if (response.deleted_at == null) {
                  JwtService.setToken(btoa(response.token));
                  localStorage.setItem("api_token", btoa(response.token));
                  localStorage.setItem(
                    "cognito_idp",
                    btoa(data.attributes["sub"])
                  );
                  this.reset_password_status = response.reset_password_flag
                  this.name = data.attributes["custom:name"];
                  this.mobile_no = data.attributes["custom:phonenumber"];
                  let user_details = {
                    user_name: data.attributes["custom:name"],
                    email: this.email,
                    mobile_no: data.attributes["custom:phonenumber"],
                    password: this.password,
                    profile_name: data.attributes["custom:name"],
                    // payment_status:response.payment_status,
                    member_id: "",
                    profile_image: "",
                    selected_value: "",
                    cognito_idp: "",
                  };
                  this.$store.dispatch(USER_DETAILS, user_details);
                  if(this.reset_password_status == 'yes'){
                    this.$router.push({ name: "SetupNewPassword" }).catch(() => {});   
                  }
                  else{
                    response.is_mobile_verified == 1? this.userProfile(): this.sendMobileOtp();
                  } 
                  this.$loading(false); 
                }
                else {
                  this.$modal.show("restore-popup");
                }
              }
            })
            .catch((err) => {
              this.$loading(false);
            });
        })
        .catch((error) => {
          this.$loading(false);
          this.isAddClassServerError = true;
          if (error.message == "User does not exist.") {
            this.serverError = "User does not Exist. Please Sign Up";
          } else if (error.code == "UserNotConfirmedException") {
            this.resendConfirmationCode(this.email);
          } else {
            this.serverError = error.message;
          }
        });
    },
    clear() {
      this.$v.$reset();
      this.email = "";
      this.password = "";
      this.checkbox = false;
    },
    restore() {
      let cognito_idp = atob(localStorage.getItem("cognito_idp"));
      // console.log(cognito_idp);
      let formdata = new FormData();
      formdata.append("aws_cognito_id", cognito_idp);
      formdata.append("email", this.email);
      axios
        .post(process.env.VUE_APP_ROOT_API + "restore-web", formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            window.location.href = "/";
          }
        })
        .catch(() => {
          this.$loading(false);
        });
    },

    onClickRememberme() {
      if (this.remember_me) {
        JwtService.setCompanyEmail(btoa(this.email));
        // JwtService.setCompanyPass(btoa(this.password));
        // JwtService.getAdminRememberMe("yes");
      } else if (!this.remember_me) {
        JwtService.setCompanyEmail("");
        // JwtService.setCompanyPass("");
        JwtService.getAdminRememberMe("");
      }
    },
    signup(evt) {
      this.$router.push({ name: "Register" }).catch(() => {});
    },
    forgotpassword(evt) {
      this.$router.push({ name: "Forgotpassword" }).catch(() => {});
    },
    showPassword() {
      if (this.passwordType == "password") {
        this.passwordType = "text";
        this.status = "Hide Password";
        this.btnText = "Hide";
      } else {
        this.passwordType = "password";
        this.status = "Show Password";
        this.btnText = "Show";
      }
    },
    userProfile() {

      if (this.$store.getters.getUserSignin.data.payment_status == "") {
          this.$router.push({ name: "pricingPlan" }).catch(() => {});
      }
      else if (this.$store.getters.getUserSignin.data.payment_status == "Free") {

        if (this.$store.getters.getUserSignin.data.is_free_plan_show == "no") {
          this.$router.push({ name: "Investometer" }).catch(() => {});

        }
        else {
          this.$router.push({ name: "Investometer" }).catch(() => {});
        }
      }
      else if (this.$store.getters.getUserSignin.data.payment_status == "ACTIVE") {
        this.is_show_payemnt_confirmation_popup = true;
        let w = window.open(
          this.$store.getters.getUserSignin.data.payment_link,
          "",
          "width=900,height=500"
        );
        setInterval(() => {
          if (
            w.closed == true &&
            this.is_show_payemnt_confirmation_popup == true
          ) {
            this.confirmPayment();
            this.is_show_payemnt_confirmation_popup = false;
          }
        }, 1000);
        this.$router.push({ name: "Investometer" }).catch(() => {});
      }
      else {
        this.$router.push({ name: "Investometer" }).catch(() => {});
      }
    },

    confirmPayment() {
      this.$store
        .dispatch(GET_PAYMENT_INFO, {
          data: {
            awsCognitoId: atob(localStorage.getItem("cognito_idp")),
            userMobile: this.mobile_no.replace("+", ""),
            user_name: this.name,
            userEmail: this.email,
          },
          api: "get-payment-info",
        })
        .then(() => {
          this.payment_link_info = this.$store.getters.getPaymentLinkInfo;
          if (this.payment_link_info.payment_status == "PAID") {
            let updatedDetail = [
              { key: "is_plan_active", value: 1 },
              {
                key: "subscription_plans",
                value: $store.getters.getPaymentLinkInfo.data.plan_id,
              },
              { key: "show_add_family_member_button", value: 1 },
            ];
            this.$store.dispatch(UPDATE_PROFILE_DETAIL, updatedDetail);
            this.$router.push({ name: "Investometer" }).catch(() => {});
          } else {
          }
        })
        .catch(() => {
          this.$loading(false);
        });
    },

    sendMobileOtp() {
      this.$store
        .dispatch(VERIFY_EMAIL_OTP, {
          data: {
            aws_cognito_id: atob(localStorage.getItem("cognito_idp")),
            mobile_no: this.$store.getters.getUserDetails.mobile_no,
          },
          api: "send-otp",
        })
        .then(() => {
          let response = this.$store.getters.getVerifyEmailOtp.data;
          if (response.status == "error") {
            this.serverError = response.message;
            return [];
          } else {
            this.$router.push({ name: "VerifyMobileOtp" }).catch(() => {});
          }
        });
    },
    resendConfirmationCode(username) {
      Auth.resendSignUp(username)
        .then((sendCode) => {
          this.$router.push({ name: "VerifyOtp" });
        })
        .catch((err) => {});
    },
  },
  beforeMount() {
    let email = localStorage.getItem('email');
    if (email) {
      this.email = email;
    }
    else if (JwtService.getCompanyEmail()) {
      this.email = atob(JwtService.getCompanyEmail());
      // this.password = atob(JwtService.getCompanyPass());
      this.remember_me = true;
    }
  },
};
</script>
